import DashboardLayout from '../components/DashboardLayout';

export default function Calendar() {
  return (
    <DashboardLayout>
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Calendar</h1>
        <div className="card">
          <p className="text-gray-600">Calendar view coming soon...</p>
        </div>
      </div>
    </DashboardLayout>
  );
}
